import { Select, chakraComponents } from "chakra-react-select";
import { ReactElement } from "react";

export type MultiSelectOption = {
  label: string;
  value: string;
};

type MultiSelectProps = {
  options: MultiSelectOption[];
  value: MultiSelectOption[];
  onChange: (value: MultiSelectOption[]) => void;
  placeholder?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
};

export const SimpleMultiSearchSelect = ({
  options,
  value,
  onChange,
  placeholder = "Sélectionner...",
  isClearable = true,
  isDisabled = false,
}: MultiSelectProps): ReactElement => {
  return (
    <Select<MultiSelectOption, true>
      isMulti
      options={options}
      value={value}
      onChange={(selected) => onChange(selected as MultiSelectOption[])}
      placeholder={placeholder}
      isClearable={isClearable}
      isDisabled={isDisabled}
      closeMenuOnSelect={true}
      chakraStyles={{
        control: (provided) => ({
          ...provided,
          borderColor: "gray.200",
          _hover: { borderColor: "gray.300" },
        }),
        multiValue: (provided) => ({
          ...provided,
          backgroundColor: "blue.100",
        }),
        multiValueLabel: (provided) => ({
          ...provided,
          color: "blue.800",
        }),
        multiValueRemove: (provided) => ({
          ...provided,
          color: "blue.500",
          _hover: {
            backgroundColor: "blue.100",
            color: "blue.700",
          },
        }),
      }}
      components={chakraComponents}
    />
  );
};
